
import React from "react";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Users, Scan, BookOpen } from "lucide-react";
import { Badge } from "@/components/ui/badge";

interface CongregationStats {
  userCount: number;
  braceletScans: number;
  journalEntries: number;
}

interface CongregationOverviewProps {
  stats: CongregationStats;
  congregationName: string;
}

export function CongregationOverview({
  stats,
  congregationName,
}: CongregationOverviewProps) {
  return (
    <Card className="mb-6 relative overflow-hidden">
      <div className="absolute top-2 right-2 flex items-center">
        <span className="relative flex h-2 w-2 mr-1">
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75"></span>
          <span className="relative inline-flex rounded-full h-2 w-2 bg-green-500"></span>
        </span>
        <span className="text-xs text-green-700">Live</span>
      </div>
      <CardHeader>
        <CardTitle>Congregation Overview</CardTitle>
        <CardDescription>Summary of {congregationName} activity</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-3 gap-4">
          <div className="flex flex-col items-center p-4 bg-gray-100 rounded">
            <Users className="h-8 w-8 text-blue-600 mb-2" />
            <span className="text-2xl font-bold">{stats.userCount}</span>
            <span className="text-sm text-gray-500">Registered Members</span>
            {stats.userCount === 0 && (
              <Badge variant="outline" className="mt-2 text-xs">No members yet</Badge>
            )}
          </div>
          <div className="flex flex-col items-center p-4 bg-gray-100 rounded">
            <Scan className="h-8 w-8 text-green-600 mb-2" />
            <span className="text-2xl font-bold">{stats.braceletScans}</span>
            <span className="text-sm text-gray-500">Bracelet Scans</span>
          </div>
          <div className="flex flex-col items-center p-4 bg-gray-100 rounded">
            <BookOpen className="h-8 w-8 text-purple-600 mb-2" />
            <span className="text-2xl font-bold">{stats.journalEntries}</span>
            <span className="text-sm text-gray-500">Journal Entries</span>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
